import React, { useEffect, useState } from 'react'
import { useChapterData } from '../hooks/chapter_data'
import { useChapterNavImageData } from '../hooks/chapter_nav_images'
import { TransitionCover } from '../components/transition'
import { Arrow } from './ui'
import { AccentBar } from './symbols'
import { useInView } from "react-intersection-observer"
import { motion } from "framer-motion"
import { useEase } from "./motion"
import { Pullstate } from '../components/pullstate'


export const ChapterNavigation = (props) => {

   const [navRef, inView] = useInView({
		triggerOnce: false,
		threshold: 0.2,
	})

	useEffect(() => {

		Pullstate.update( s => {
			s.isChapterNavInView = inView
		})

	}, [inView])

   const prevIn = {
      closed: {
			scaleY: 1,
			transformOrigin: 'top',
			transition: {
				ease: useEase('easeOutQuart'),
				duration: 1
			},
		},
		open: {
			scaleY: 0,
			transformOrigin: 'top',
			transition: {
				ease: useEase('easeOutQuart'),
				duration: 1,
				delay: 0.4
			},
		}
   }
   const nextIn = {
		closed: {
			scaleY: 1,
			transformOrigin: "bottom",
			transition: {
				ease: useEase('easeOutQuart'),
				duration: 1,
			},
		},
		open: {
			scaleY: 0,
			transformOrigin: "bottom",
			transition: {
				ease: useEase('easeOutQuart'),
				duration: 1,
				delay: 0.4
			},
		},
   }

   const currentNum = props.index;

   const prev = 'chapter' + (currentNum - 1)
   const next = 'chapter' + (currentNum + 1)

   const chapterData = useChapterData()
	const navImageData = useChapterNavImageData()

	let prevTitle, prevSlug, prevClasses, prevImage, number, prevNum, nextTitle, nextSlug, nextClasses, nextImage, nextNum;

	if ( currentNum > 1 ) {
		prevTitle = props.prevTitle ? props.prevTitle : chapterData[prev].chapter_title
		prevSlug = chapterData[prev].UID
		prevClasses = `chapterNav_box chapterNav_${prev} prevNavContainer`
		prevImage = navImageData[prev].childImageSharp.fluid.src ? navImageData[prev].childImageSharp.fluid.src : ''
		number = chapterData[prev].chapter_number
		prevNum = `${("0" + number).slice(-2)}.`
	}
	if ( currentNum < 20 ) {
		nextTitle = props.nextTitle ? props.nextTitle : chapterData[next].chapter_title
		nextSlug = chapterData[next].UID
		nextClasses = `chapterNav_box chapterNav_${next} nextNavContainer`
		nextImage = navImageData[next].childImageSharp.fluid.src ? navImageData[next].childImageSharp.fluid.src : ''
		number = chapterData[next].chapter_number
		nextNum = `${("0" + number).slice(-2)}.`
	} else {
		nextTitle = chapterData.chapter1.chapter_title
		nextSlug = chapterData.chapter1.UID
		nextClasses = `chapterNav_box chapterNav_chapter1 nextNavContainer`
		nextImage = navImageData.chapter1.childImageSharp.fluid.src ? navImageData.chapter1.childImageSharp.fluid.src : ''
		number= chapterData.chapter1.chapter_number
		nextNum = `${( '0' + number ).slice(-2)}.`
	}

   return (
		<section id='chapterNav' className="chapter-navigation" ref={navRef}>
			{currentNum > 1 && (
				<article
					className={prevClasses}
					style={{
						backgroundImage: `url(${prevImage})`,
						backgroundPosition: props.prevPos
							? props.prevPos
							: "center",
					}}
				>
					<motion.div
						className="navScreen prevScreen"
						initial="closed"
						animate={inView ? "open" : "closed"}
						variants={prevIn}
						exit="closed"
					></motion.div>
					<div className="shadowBox">
						<AccentBar theme="dark">
							<div className="chapterNav_tag">
								{prevNum}
							</div>
						</AccentBar>
						<div className="chapterNav_title">{prevTitle}</div>
						<TransitionCover
							cover
							to={`/${prevSlug}`}
							direction="up"
							duration={1.8}
							bg="#ff0000"
						>
							<Arrow theme="dark" direction="left" />
						</TransitionCover>
					</div>
				</article>
			)}

			<article
				className={nextClasses}
				style={{
					backgroundImage: `url(${nextImage})`,
					backgroundPosition: props.nextPos
						? props.nextPos
						: "center",
				}}
			>
				<motion.div
					className="navScreen nextScreen"
					initial="closed"
					animate={inView ? "open" : "closed"}
					variants={nextIn}
					exit="closed"
				></motion.div>
				<div className="shadowBox">
					<AccentBar theme="dark">
						<div className="chapterNav_tag">{nextNum}</div>
					</AccentBar>
					<div className="chapterNav_title">{nextTitle}</div>
					<TransitionCover
						cover
						to={`/${nextSlug}`}
						direction="up"
						duration={1.8}
						bg="#ff0000"
					>
						<Arrow theme="dark" direction="right" />
					</TransitionCover>
				</div>
			</article>
		</section>
   )
}
